import React from 'react';
import { Link } from 'react-router-dom';

function FamilyLaw() {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1>Family Law Services</h1>
        <p>Compassionate guidance through life's most challenging transitions</p>
      </div>

      <section className="content-section">
        <div className="text-content">
          <p>Family law matters are deeply personal and emotionally challenging. At Sol LLP, we understand that you're not just dealing with legal issues—you're navigating major life changes that affect your children, your finances, and your future. Our experienced family law team provides compassionate support combined with strategic advocacy to protect your interests and help you move forward.</p>

          <h3>Divorce & Separation</h3>
          <p>We guide clients through all aspects of divorce and separation, including uncontested divorces, contested proceedings, and separation agreements. Our goal is to achieve fair resolutions efficiently, whether through negotiation, mediation, or litigation. We handle:</p>
          <ul>
            <li>Divorce applications and proceedings</li>
            <li>Separation agreements</li>
            <li>Division of matrimonial property and debt</li>
            <li>Spousal support (alimony)</li>
            <li>Court representation</li>
          </ul>

          <h3>Child Custody & Access</h3>
          <p>Your children's wellbeing is paramount. We help parents establish custody arrangements and parenting plans that serve the best interests of the children while protecting parental rights. Our services include:</p>
          <ul>
            <li>Custody determinations (sole, joint, shared)</li>
            <li>Parenting time schedules</li>
            <li>Access and visitation rights</li>
            <li>Relocation disputes</li>
            <li>Parenting coordination</li>
            <li>Modification of existing orders</li>
          </ul>

          <h3>Child & Spousal Support</h3>
          <p>We assist clients in determining, negotiating, and enforcing fair support obligations based on BC Family Law Act and Federal Child Support Guidelines:</p>
          <ul>
            <li>Child support calculations and agreements</li>
            <li>Special and extraordinary expenses</li>
            <li>Spousal support determinations</li>
            <li>Support modification and enforcement</li>
            <li>Income imputation and disclosure</li>
          </ul>

          <h3>Property Division</h3>
          <p>BC's family property laws require equal division of family property and proportionate sharing of debt. We ensure accurate valuation and fair distribution of:</p>
          <ul>
            <li>Family homes and real estate</li>
            <li>Pensions and RRSPs</li>
            <li>Business interests</li>
            <li>Investments and savings</li>
            <li>Excluded property claims</li>
          </ul>

          <h3>Prenuptial & Cohabitation Agreements</h3>
          <p>Protect your assets and clarify expectations with carefully drafted agreements before marriage or cohabitation. We provide clear legal advice and ensure agreements are enforceable.</p>

          <h3>Our Approach</h3>
          <p>While we're always prepared to litigate when necessary, we also explore collaborative law, mediation, and negotiated settlements to reduce conflict and costs. Every family is unique, and we tailor our approach to your specific circumstances and goals.</p>

          <div style={{ marginTop: '40px', padding: '30px', background: '#f7fafc', borderRadius: '8px', textAlign: 'center' }}>
            <h3>Ready to Discuss Your Family Law Matter?</h3>
            <p>Contact us today for a confidential consultation. We're here to help you navigate this challenging time with clarity and confidence.</p>
            <Link to="/contact" className="cta-button" style={{ marginTop: '20px' }}>Schedule Your Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FamilyLaw;

